function Aboutus(){
    return(
        <>
         <div className="page-title" data-aos="fade">
      <div className="container">
        <nav className="breadcrumbs">
          <ol>
            <li><a href="index.html">Home</a></li>
            <li className="current">About Us</li>
          </ol>
        </nav>
        <h1>About Us</h1>
      </div>
    </div>
    <section id="team" className="team section">
        <div className="container">
            CA Sanjay Prasad & Associates is a reputable chartered accountancy firm committed to delivering expert services in accounting, taxation, auditing, and corporate advisory. With a strong focus on client needs, we provide customized financial solutions designed to support the growth and success of both businesses and individuals through dependable advice and professional excellence.


        </div>


    </section>
        </>
    );
}

export default Aboutus;